<template>
    <div class="vipt">
        <div class="screen">
            <el-cascader v-model="value" :options="options" placeholder="类型筛选:" @change="handleChange" />
        </div>
        <div class="search">
            <div style="width: 24px;height: 24px;">
                <img style="width: 100%;height: 100%;" src="../assets/secree.png" alt="">
            </div>
            <div>
                <input type="text" placeholder="关键字搜索" v-model="keyword" @keyup.enter="seach">
            </div>
        </div>
        <div class="calendar">
            <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                start-placeholder="" end-placeholder="" @change="changedata" format="MM.DD" :clearable="true" />
        </div>
    </div>
    <div class="vipporpe" v-loading="loading">
        <table>
            <thead>
                <tr>
                    <th>
                        <!-- <el-checkbox /> -->
                    </th>
                    <th>商铺名称</th>
                    <th>商铺类型</th>
                    <th>保证金</th>
                    <th>注册时间</th>
                    <th>状态</th>
                    <th>操作</th>


                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in StoreDatalist ">
                    <td>
                        <el-checkbox />

                    </td>
                    <td>
                        <div class="stroeh">
                            <!-- <div class="header">
                                <img src="" alt="">
                            </div> -->
                            <div class="storename">
                                <div>{{ item.storeName }}</div>
                                <div class="stid">ID: {{ item.userId }}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        {{ item.storeIndustry }}
                    </td>
                    <td>
                        {{ item.storeMarginAmount || 0 }}

                    </td>
                    <td>
                        {{ dateString(item.applyTime) }}
                    </td>
                    <td>
                        <div class="statea">
                            {{ storeApplyStatus(item.storeApplyStatus) }}
                        </div>
                    </td>
                    <td @click="applyStatus(item.userId)" style="cursor: pointer;">
                        通过审核
                    </td>
                </tr>
            </tbody>
        </table>
        <div style=" height: 70px;"></div>


    </div>
    <div class="pagechoose">

        显示结果：

        <div class="pagees">

            <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

        </div>

    </div>
    <Noshu :disabled="loading" :lengths="StoreDatalist.length" ></Noshu>

    <div class="example-pagination-block">
        <el-pagination class="example-pagination-block" background v-model:current-page="current"
            :default-page-size="pageSize" layout="prev, pager, next" :pager-count="5" :total="totals"
            @current-change="changepige" :disabled="loading" />
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router';
import storeapi from '@/api/store'
import { ElMessage, ElMessageBox } from 'element-plus'
import Noshu from '@/components/Noshu.vue'
import { inject } from 'vue';

const reload = inject("reload");
let current = ref(1)
let keyword = ref('')
let startDate = ref('')
let endDate = ref('')
let StoreDatalist = ref([])
let totals = ref(100)

onMounted(() => {
    storelist()
})
let loading = ref(false)

const storeApplyStatus = (storeApplyStatus) => {
    if (storeApplyStatus == -1) {
        return '审核失败'
    } else if (storeApplyStatus == 0) {
        return '审核中'
    } else if (storeApplyStatus == 1) {
        return '审核成功'
    }
}
const dateString = (dateString) => {
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}-${month}-${day}`
}
const applyStatus = (id) => {
    ElMessageBox.confirm(
        '确定通过审核？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {

            alterAuditStatus(id)

        })
        .catch(() => {

        })
}
const alterAuditStatus = async (id) => {
    const res = await storeapi.alterAuditStatus(id)
    console.log(res)
    if (res.success) {
        storelist()

        // reload();
    }
}

let pageSize = ref(5)

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    storelist()
}
let keywordType = ref(1)
//待审核店铺
const storelist = async () => {
    loading.value = true

    try {
        let data
        if (startDate.value.length > 1) {
            data = {

                "endDate": endDate.value,
                "keyword": keyword.value,
                "keywordType": keywordType.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                },
                "startDate": startDate.value
            }
        } else {
            data = {
                "keyword": keyword.value,
                "keywordType": keywordType.value,
                "page": {
                    "current": current.value,
                    "pageSize": pageSize.value
                }
            }
        }
        const res = await storeapi.pageStoreApply(data)
        console.log('待审核店铺', res)
        if (res.success) {
            let rec = res.data.records
            // rec = rec.filter(item => item.storeApplyStatus !== 1);
            let total = res.data.total
            totals.value = res.data.total
            console.log('total.value', totals.value, total)
            StoreDatalist.value = rec
            loading.value = false
        } else {
            loading.value = false

        }
    } catch (error) {
        // 处理错误
    }
}

//上一页
const prev = () => {
    current.value--
    storelist()
    console.log(current.value)

}
//下一页
const nextpige = () => {
    current.value++
    storelist()
    console.log(current.value)

}
//跳转页面
const changepige = (val) => {
    console.log(val)
    current.val = val
    storelist()
}
//搜索
const seach = () => {
    storelist()
}
const router = useRouter()
const gomessage = () => {
    router.push('/home/shopDetails')
}
const value = ref([])
const value2 = ref(5)
const colors = ref(['#FF2928', '#FF2928', '#FF2928'])
const options = reactive([

    {
        value: '1',
        label: '店铺',
    }
])
const handleChange = (value) => {
    // console.log(value)
    keywordType.value = value[0]
    console.log(keywordType.value)

}
const nowdata = new Date()
const choosedata = ref([nowdata, nowdata])
const changedata = (e) => {
    if (e == null) {
        e = ['', '']
    }
    console.log(e)
    startDate.value = datahuan(e[0])
    endDate.value = datahuan(e[1])
    console.log(startDate.value)
    console.log(endDate.value)
    current.value = 1
    storelist()
}
const datahuan = (days) => {
    if (days) {
        const date = new Date(days);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补零
        const day = date.getDate().toString().padStart(2, '0'); // 补零
        return `${year}-${month}-${day}`;
    } else {
        return ''
    }

}

</script>

<style lang="scss" scoped>
::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;


    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .example-pagination-block {
    position: absolute;
    bottom: 15px;
    right: 34px;



    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .is-active {
        background-color: #FAFAFA !important;
        color: #1787FF !important;
        border-radius: 8px;
    }


}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }

}

::v-deep .el-checkbox__input {
    height: 20px;

    .el-checkbox__inner {
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }

    .el-checkbox__inner {
        &::after {
            top: 4px;
            left: 8px;
        }

    }
}

.pagechoose {
    position: absolute;
    bottom: 0px;
    left: 14px;
    width: 100%;
    height: 70px;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .pagees {
        width: 71px;
        height: 40px;
        border: 1px solid #EEEFF2;
        border-radius: 8px;
        padding: 8px 0 0 0px;
        box-sizing: border-box;

        input {
            width: 80%;


        }
    }
}

.vipt {
    padding-top: 9px;
    margin-left: 15px;
    display: flex;

    .screen {
        width: 168px;
        height: 48px;
        background: #F8F8F8;
        border-radius: 8px;
        margin-right: 24px;
    }

    .search {
        width: 412px;
        height: 48px;
        margin-right: 24px;
        background: #F8F8F8;
        box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;

        input {
            width: 300px;
            border: none;
            outline: none;
            font-size: 16px;
            background: #F8F8F8;

        }

        ::placeholder {
            font-weight: 400;
            font-size: 14px;
            color: #7D8592;
        }
    }

    .calendar {
        width: 168px;
        height: 48px;
        background: #FAFAFA;
        border-radius: 8px;
    }

}

.vipporpe {
    width: 100%;
    padding-left: 15px;
    box-sizing: border-box;



    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
            text-align: left;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;
            border-bottom: 1px solid #EEEFF2;
            display: table-header-group;
            height: 46px;

            th {

                vertical-align: middle;

            }

            .states {
                text-align: center;
            }
        }

        tbody {
            tr {
                height: 96px;
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                border-bottom: 1px solid #EEEFF2;

                td:nth-child(2) {
                    .stroeh {
                        display: flex;

                        .header {
                            width: 56px;
                            height: 56px;
                            background-color: #718096;
                            border-radius: 8px;
                            margin-right: 24px;
                        }

                        .storename {
                            font-size: 16px;

                            font-weight: 400;
                            color: #111827;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .stid {
                                font-size: 14px;
                                font-family: HelveticaNeue;
                                color: #718096;
                            }
                        }

                    }
                }

                td:last-child {

                    color: #1787FF;

                }

                td {

                    vertical-align: middle;

                    .statea {
                        width: 66px;
                        height: 42px;
                        background: #EBF3FF;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        font-weight: 400;
                        color: #1787FF;
                    }


                }


            }
        }

    }
}
</style>